module.exports = __webpack_public_path__ + "static/img/swipe_1.36a743c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Zuzuche/swipe_1.png
// module id = YlV4
// module chunks = 19